module.exports = __webpack_public_path__ + "img/huqingsong.f384e973.jpg";